(function () {
  'use strict';

  document.querySelectorAll('[data-collection-slider]').forEach(initSlider);

  function initSlider(section) {
    var slides = section.querySelectorAll('[data-slide]');
    var dots = section.querySelectorAll('[data-dot]');
    var prevBtn = section.querySelector('[data-prev]');
    var nextBtn = section.querySelector('[data-next]');
    var galleryEl = section.querySelector('[data-gallery]');
    var productNameEl = section.querySelector('[data-product-name-display]');
    var productSeriesEl = section.querySelector('[data-product-series-display]');
    var productColorEl = section.querySelector('[data-product-color-display]');
    var galleryNameEl = section.querySelector('[data-gallery-name]');
    var viewMoreEl = section.querySelector('[data-view-more]');
    var reserveEl = section.querySelector('[data-reserve]');

    var activeIndex = 0;
    var total = slides.length;
    var isAnimating = false;

    if (total === 0) return;

    // On mobile, eagerly load every slide image so tapping prev/next doesn't
    // trigger a fresh network fetch. Desktop keeps lazy loading.
    if (window.matchMedia('(max-width: 768px)').matches) {
      slides.forEach(function (slide) {
        var img = slide.querySelector('.collection-slider__slide-img');
        if (img && img.getAttribute('loading') === 'lazy') {
          img.setAttribute('loading', 'eager');
          img.fetchPriority = 'high';
        }
      });
    }

    // Parse slide data — gallery images are || delimited, variable count
    var slideData = [];
    slides.forEach(function (slide) {
      var rawImages = slide.dataset.galleryImages || '';
      var images = rawImages ? rawImages.split('||').filter(function(s) { return s.length > 0; }) : [];

      slideData.push({
        name: slide.dataset.productName || '',
        series: slide.dataset.productSeries || '',
        galleryImages: images,
        productUrl: slide.dataset.productUrl || '#',
        reserveUrl: slide.dataset.reserveUrl || '#',
        productId: slide.dataset.productId || '',
        variantId: slide.dataset.variantId || '',
        productTitle: slide.dataset.productTitle || '',
        productImage: slide.dataset.productImage || '',
        productPrice: slide.dataset.productPrice || '',
        productHandle: slide.dataset.productHandle || '',
        productColor: slide.dataset.productColor || ''
      });
    });

    // Preload all gallery images
    slideData.forEach(function (data) {
      data.galleryImages.forEach(function (src) {
        if (src) {
          var img = new Image();
          img.src = src;
        }
      });
    });

    function buildGallery(data) {
      if (!galleryEl) return;

      // Fade out existing images
      var existingImgs = galleryEl.querySelectorAll('.collection-slider__gallery-img');
      existingImgs.forEach(function (img) {
        img.style.opacity = '0';
      });

      setTimeout(function () {
        galleryEl.innerHTML = '';
        var images = data.galleryImages.slice();
        if (images.length < 2 && data.productImage) {
          images.push(data.productImage);
        }
        var count = Math.min(images.length, 2);
        if (count === 0) return;

        for (var i = 0; i < count; i++) {
          (function(idx) {
            var img = document.createElement('img');
            img.className = 'collection-slider__gallery-img';
            img.setAttribute('data-gallery-img', '');
            img.alt = data.name;
            img.style.opacity = '0';
            img.src = images[idx];
            galleryEl.appendChild(img);
            // Double rAF ensures browser paints at opacity 0 before transitioning
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                img.style.opacity = '1';
              });
            });
          })(i);
        }
      }, 300);
    }

    function goTo(newIndex) {
      if (newIndex === activeIndex || isAnimating) return;
      if (newIndex < 0) newIndex = total - 1;
      if (newIndex >= total) newIndex = 0;
      isAnimating = true;

      var data = slideData[newIndex];

      // Update slider slides
      slides[activeIndex].classList.remove('is-active');
      slides[newIndex].classList.add('is-active');

      // Update dots
      dots.forEach(function (dot) { dot.classList.remove('is-active'); });
      if (dots[newIndex]) dots[newIndex].classList.add('is-active');

      // Rebuild gallery with this product's images
      buildGallery(data);

      // Update text
      if (productNameEl) productNameEl.textContent = data.name;
      if (productSeriesEl) productSeriesEl.textContent = data.series;
      if (productColorEl) productColorEl.textContent = data.productColor;
      if (galleryNameEl) galleryNameEl.textContent = data.name;

      // Update CTAs
      if (viewMoreEl) viewMoreEl.href = data.productUrl;
      if (reserveEl) {
        reserveEl.href = data.reserveUrl;
        reserveEl.dataset.productId = data.productId;
        reserveEl.dataset.variantId = data.variantId;
        reserveEl.dataset.productTitle = data.productTitle;
        reserveEl.dataset.productImage = data.productImage;
        reserveEl.dataset.productPrice = data.productPrice;
        reserveEl.dataset.productHandle = data.productHandle;
      }

      activeIndex = newIndex;

      setTimeout(function () {
        isAnimating = false;
      }, 450);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.dot, 10));
      });
    });

    section.setAttribute('tabindex', '0');
    section.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        goTo(activeIndex + 1);
      } else if (e.key === 'ArrowLeft') {
        goTo(activeIndex - 1);
      }
    });
  }
})();
